module.exports = __webpack_public_path__ + "img/gb68.prt.3adcfe29.jpg";